export class EducationPolicy{
    id : number;
    code : string;
    name : string; 
    /*Ho tro khac*/
    IsRequiredNote : boolean;
    DisplayOrder : number;
  } 